import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api, { setApiViewAs, clearApiViewAs } from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [viewAs, setViewAsState] = useState(null);

  const checkAuth = useCallback(async () => {
    try {
      const data = await api.me();
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
    const handler = () => { setUser(null); setLoading(false); };
    window.addEventListener('ledger-session-expired', handler);
    return () => window.removeEventListener('ledger-session-expired', handler);
  }, [checkAuth]);

  const handleLogin = (userData) => setUser(userData);

  const logout = async () => {
    try { await api.logout(); } catch {}
    setUser(null);
    setViewAsState(null);
    clearApiViewAs();
  };

  const setViewAs = (username) => {
    setViewAsState(username);
    setApiViewAs(username);
  };

  const clearViewAs = () => {
    setViewAsState(null);
    clearApiViewAs();
  };

  return (
    <AuthContext.Provider value={{ user, loading, handleLogin, logout, viewAs, setViewAs, clearViewAs }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
